"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class FetchEntitiesByUserIdsDoesNotExistError extends client_library_1.ExtendableError {
    constructor() {
        super(`School entities cannot be found for provided userIds`);
    }
}
exports.default = FetchEntitiesByUserIdsDoesNotExistError;
//# sourceMappingURL=FetchEntitiesByUserIdsDoesNotExistError.js.map